import { createReducer, on } from "@ngrx/store";
import { ClientActions } from "./client.actions";
import { ClientModel } from "../../models/client.model";
import { Plan } from "../../class/plan.class";

export interface ClientState {
    client: ClientModel | null,
    plan: Plan | null,
    token_left: number,
    token_per_month: number,
}

export const initialState: Readonly<ClientState> = {
    client: null,
    plan: null,
    token_left: 0,
    token_per_month: 0,
};

export const ClientReducer = createReducer(
    initialState,
    on(ClientActions.loginClient, (state, { client }) => {
        return {
            ...state,
            client: client
        }
    }),
    on(ClientActions.logoutClient, () => initialState),
    on(ClientActions.setPlan, (state, { plan }) => {
        return {
            ...state,
            plan: plan,
        }
    }),
    on(ClientActions.setTokens, (state, { tokens }) => {
        return {
            ...state,
            token_left: tokens
        }
    }),
    on(ClientActions.addTokens, (state, { tokens }) => {
        return {
            ...state,
            token_left: state.token_left + tokens
        }
    }),
    on(ClientActions.setTokensPerMonth, (state, { tokens }) => {
        return {
            ...state,
            token_per_month: tokens
        }
    })
)